// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_e27_base/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_e27_base: ModuleSchema = {
  "id": "core_e27_base",
  "uniqueId": "B3D_E27BS",
  "createdAt": "2026-10-02T06:00:19.106Z",
  "updatedAt": "2026-10-28T14:58:31.441Z",
  "label": "E27 Shell",
  "description": "core_e27_base parametric 3D model",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_E27"
  ],
  "sliders": [
    {
      "key": "baseType",
      "label": "Base Style (0: Tall 100mm, 1: Low 40mm+Tower)",
      "min": 0,
      "max": 1,
      "step": 1,
      "default": 0,
      "unit": ""
    },
    {
      "key": "baseDia",
      "label": "Tall Base Outer Diameter (Ø)",
      "min": 90,
      "max": 140,
      "step": 1,
      "default": 110,
      "unit": "mm"
    },
    {
      "key": "baseH",
      "label": "Tall Base Height",
      "min": 60,
      "max": 130,
      "step": 1,
      "default": 100,
      "unit": "mm"
    },
    {
      "key": "wallThickness",
      "label": "Lightweight Outer Wall Thickness",
      "min": 10,
      "max": 35,
      "step": 1,
      "default": 10,
      "unit": "mm"
    },
    {
      "key": "lowBaseDia",
      "label": "Low Base Disc Diameter (Ø)",
      "min": 110,
      "max": 160,
      "step": 1,
      "default": 130,
      "unit": "mm"
    },
    {
      "key": "towerH",
      "label": "Low Base Tower Height",
      "min": 20,
      "max": 45,
      "step": 1,
      "default": 30,
      "unit": "mm"
    },
    {
      "key": "baseRibCount",
      "label": "Outer Rib Count",
      "min": 0,
      "max": 24,
      "step": 1,
      "default": 0,
      "unit": ""
    },
    {
      "key": "baseTextureType",
      "label": "3D Texture (0:None, 1:Fluting, 2:Rattan, 3:Knurl, 4:Wood, 5:Stone)",
      "min": 0,
      "max": 5,
      "step": 1,
      "default": 0,
      "unit": ""
    },
    {
      "key": "screwPcd",
      "label": "Foot Screws PCD (Ø)",
      "min": 70,
      "max": 105,
      "step": 1,
      "default": 85,
      "unit": "mm"
    },
    {
      "key": "cableTunnelPadWidth",
      "label": "Cable Opening Width at Bottom",
      "min": 3,
      "max": 8,
      "step": 0.5,
      "default": 4.5,
      "unit": "mm"
    },
    {
      "key": "cableTunnelLegHeight",
      "label": "Cable Pad Thickness",
      "min": 0,
      "max": 8,
      "step": 0.5,
      "default": 1.5,
      "unit": "mm"
    },
    {
      "key": "cableTunnelPadRaise",
      "label": "Cable Tunnel Pad Raise",
      "min": 0,
      "max": 6,
      "step": 0.5,
      "default": 0,
      "unit": "mm"
    },
    {
      "key": "screwThreadRadialClearance",
      "label": "Screw Thread Clearance per Side",
      "min": 0.2,
      "max": 0.8,
      "step": 0.05,
      "default": 0.4,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "e27_base",
      "label": "E27 Lamp Base Shell",
      "default": "#78350f",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "e27_base_obj",
      "label": "E27 Lamp Base",
      "name": "E27 Lamp Base",
      "color": "#78350f",
      "assembled_z_offset": 0,
      "exploded_z_offset": 25,
      "parts": [
        {
          "id": "e27_base",
          "label": "E27 Lamp Base Shell",
          "name": "E27 Lamp Base Shell",
          "groupId": 0,
          "colorKey": "e27_base",
          "defaultColor": "#78350f",
          "assembled_z_offset": 0,
          "exploded_z_offset": 25,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": []
};
